import { render, staticRenderFns } from "./ProfilePage.vue?vue&type=template&id=bec0ac84&scoped=true"
import script from "./ProfilePage.vue?vue&type=script&lang=js"
export * from "./ProfilePage.vue?vue&type=script&lang=js"
import style0 from "./style.scss?vue&type=style&index=0&id=bec0ac84&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bec0ac84",
  null
  
)

export default component.exports